"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Mon307TalkToSalesAuthedCta = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/Mon307TalkToSalesAuthedCta"));

var _Tracking = require("pricing-pages-unified-ui/constants/Tracking");

var _colors = require("HubStyleTokens/colors");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  left: 0;\n  transform: rotate(90deg) translateY(45px);\n  margin-top: 65px;\n  background: white;\n  padding: 10px;\n  border-radius: 8px 8px 0 0;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n  border: 2px solid ", ";\n  border-bottom: none;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: sticky;\n  top: 70px;\n  z-index: 2;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SideFab = _styledComponents.default.div.withConfig({
  displayName: "Mon307Fab__SideFab",
  componentId: "sc-179m1lz-0"
})(_templateObject());

var AbsoluteInner = _styledComponents.default.div.withConfig({
  displayName: "Mon307Fab__AbsoluteInner",
  componentId: "sc-179m1lz-1"
})(_templateObject2(), _colors.CALYPSO);

var Mon307Fab = function Mon307Fab(_ref) {
  var hub = _ref.hub;
  return _react.default.createElement(SideFab, null, _react.default.createElement(AbsoluteInner, null, _react.default.createElement(_Mon307TalkToSalesAuthedCta.default, {
    hub: hub,
    location: _Tracking.SIDE_FAB,
    isPurple: true
  })));
};

var _default = Mon307Fab;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/Mon307Fab.js
// module id = 263
// module chunks = 5 6